// RED FLAG — bilingual content
export const BRAND = {
  name: "RED FLAG",
  domain: "red-flag.ch",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_pro-landing-56/artifacts/3p9mj54a_205B26A1-0023-4DD2-A975-612273C67A28.png",
};

export const translations = {
  de: {
    nav: {
      home: "Home",
      podcast: "Podcast",
      academy: "Academy",
      about: "Über",
      contact: "Kontakt",
      cta: "Membership",
    },
    hero: {
      eyebrow: "Erkenne die Warnsignale,",
      titleLine1: "Bevor sie dein",
      titleLine2: "Leben bestimmen.",
      subtitle:
        "Der RED FLAG Podcast nennt, was du längst weisst — und gibt dir die Sprache, die fehlt. Beziehungen, Psyche, Beruf, Gesellschaft. Schonungslos klar.",
      ctaPrimary: "Podcast anhören",
      ctaSecondary: "Mehr erfahren",
      pillars: [
        { title: "Podcast", desc: "Jeden Montag. Keine Floskeln. Kein Coaching-Sprech." },
        { title: "Academy", desc: "Wissen, das du nirgendwo sonst hörst." },
        { title: "Community", desc: "Menschen, die hinsehen — statt wegzuschauen." },
        { title: "Mission", desc: "Bewusstsein schaffen. Punkt." },
      ],
    },
    categories: {
      overline: "Themenbereiche",
      title: "Sechs Bereiche. Eine Wahrheit.",
      subtitle:
        "Die Warnsignale sind überall — du musst sie nur lesen lernen. Beziehung. Psyche. Beruf. Gesellschaft. Wir nehmen sie auseinander.",
      items: [
        {
          slug: "beziehungen",
          icon: "Heart",
          title: "Beziehungen",
          tags: "Narzissmus · Gaslighting · Betrug · Co-Abhängigkeit",
          desc: "Die roten Fahnen erkennen, bevor die Beziehung dich zerstört.",
        },
        {
          slug: "psychologie",
          icon: "Brain",
          title: "Psychologie",
          tags: "Trauma · Bindung · Manipulation · Schatten",
          desc: "Verstehe die Muster, die dich seit Jahren gefangen halten.",
        },
        {
          slug: "maenner",
          icon: "User",
          title: "Männer",
          tags: "Dating · Maskulinität · Kommunikation",
          desc: "Klarheit in Rollen, die niemand mehr erklärt — schonungslos ehrlich.",
        },
        {
          slug: "frauen",
          icon: "UserCircle",
          title: "Frauen",
          tags: "Wert · Grenzen · Selbstrespekt",
          desc: "Was du nie gelernt hast — über dich und das andere Geschlecht.",
        },
        {
          slug: "beruf",
          icon: "Briefcase",
          title: "Beruf",
          tags: "Toxische Chefs · Burnout · Mobbing",
          desc: "Wenn der Job dich auffrisst — Warnsignale in Organisationen.",
        },
        {
          slug: "gesellschaft",
          icon: "Globe2",
          title: "Gesellschaft",
          tags: "Gruppendruck · Medien · Manipulation",
          desc: "Wo Mehrheiten irren — und wie du klar bleibst.",
        },
      ],
    },
    podcast: {
      overline: "RED FLAG Podcast",
      title: "Wöchentliche Folgen, die nichts beschönigen.",
      subtitle:
        "Jeden Montag eine neue Episode. Auf Spotify, Apple Podcasts und überall, wo Podcasts gehört werden.",
      ctaAll: "Alle Folgen",
      ctaListen: "Anhören",
    },
    selftest: {
      overline: "Selbsttest",
      title: "Wie viele Red Flags befinden sich aktuell in deinem Leben?",
      subtitle:
        "Beantworte 12 ehrliche Fragen. Erhalte sofort eine klare Auswertung — anonym, kostenlos, ohne Anmeldung.",
      cta: "Test starten",
      note: "≈ 4 Minuten · Ehrliche Antworten erwartet",
    },
    testimonials: {
      overline: "Community-Stimmen",
      title: "Was Hörer:innen sagen.",
      items: [
        {
          quote:
            "Nach drei Folgen hatte ich die Wahrheit über meine Beziehung — die ich seit fünf Jahren verdrängt habe.",
          name: "Lisa M.",
          role: "Zürich",
        },
        {
          quote:
            "RED FLAG hat mir das Vokabular gegeben, um endlich zu verstehen, was mit mir und meinem Chef passiert.",
          name: "David K.",
          role: "Hamburg",
        },
        {
          quote:
            "Klar, schonungslos, aber nie zynisch. Genau die Stimme, die in unserer Welt fehlt.",
          name: "Anna R.",
          role: "Wien",
        },
      ],
    },
    membership: {
      overline: "Membership",
      title: "Drei Wege, tiefer einzusteigen.",
      subtitle:
        "Vom kostenfreien Einstieg bis zur engen Community. Wähle, wie weit du gehen willst.",
      tiers: [
        {
          name: "Free",
          price: "CHF 0",
          period: "",
          desc: "Der wöchentliche Podcast und das Newsletter-Briefing.",
          features: [
            "Podcast — alle Folgen frei",
            "Newsletter jeden Sonntag",
            "Zugang zum Selbsttest",
          ],
          cta: "Kostenlos starten",
        },
        {
          name: "Insider",
          price: "CHF 19",
          period: "/ Monat",
          desc: "Vertiefende Inhalte und Live-Sessions für ernsthaft Interessierte.",
          features: [
            "Alles aus Free",
            "Bonus-Folgen & Deep-Dives",
            "Monatliche Live-Q&A",
            "Mini-Kurse (Beziehungen, Psyche, Beruf)",
            "Werbefreier Feed",
          ],
          cta: "Insider werden",
          highlight: true,
          badge: "Beliebt",
        },
        {
          name: "Inner Circle",
          price: "CHF 99",
          period: "/ Monat",
          desc: "Direkter Zugang. Kleine Gruppe. Echte Transformation.",
          features: [
            "Alles aus Insider",
            "Private Community (max. 200)",
            "Monatlicher Gruppencall",
            "SAT-Lösungspfad: 30% Rabatt",
            "Persönliche Sprachnachricht zum Geburtstag",
          ],
          cta: "Bewerben",
        },
      ],
    },
    ecosystem: {
      overline: "Das Ökosystem",
      title: "RED FLAG ist nur der Anfang.",
      subtitle:
        "Drei Marken — eine Mission. RED FLAG zeigt die Warnsignale, die Schweizer Akademie für Transformation GmbH führt durch echte Veränderung, und die Herzbewegung trägt das Ergebnis in die Welt.",
      steps: [
        {
          tag: "01",
          name: "RED FLAG",
          role: "Erkennen",
          desc: "Du siehst, was da ist — ohne dich länger zu belügen.",
        },
        {
          tag: "02",
          name: "SAT",
          role: "Transformieren",
          desc: "Die Akademie führt dich durch echte Veränderung.",
        },
        {
          tag: "03",
          name: "Herzbewegung",
          role: "Verkörpern",
          desc: "Du gibst weiter, was dich verändert hat. Die Bewegung.",
        },
      ],
    },
    faq: {
      overline: "Häufige Fragen",
      title: "Was du wissen solltest.",
      items: [
        {
          q: "Ist RED FLAG eine Therapie oder ein Coaching?",
          a: "Nein. RED FLAG ist eine Aufklärungsplattform. Wir geben Sprache, Modelle und Muster an die Hand — keine Diagnosen. Für tiefe Arbeit verweisen wir auf SAT oder qualifizierte Therapeut:innen.",
        },
        {
          q: "Wie unterscheidet sich RED FLAG von SAT und Herzbewegung?",
          a: "RED FLAG zeigt die Warnsignale (Erkennen). SAT bietet den Transformationsweg (Verändern). Herzbewegung trägt das Ergebnis in die Welt (Verkörpern). Drei Marken, ein klarer Pfad.",
        },
        {
          q: "Wie oft erscheint der Podcast?",
          a: "Jeden Montag, 06:00 Uhr. Insider erhalten zusätzlich Bonus-Folgen und Deep-Dives.",
        },
        {
          q: "Kann ich Mitglied werden, ohne den Podcast zu kennen?",
          a: "Ja. Wir empfehlen aber die ersten drei Folgen vorher zu hören — du erkennst schnell, ob unsere Sprache zu dir passt.",
        },
        {
          q: "Wie kündige ich die Membership?",
          a: "Jederzeit mit einem Klick im Account. Keine Mindestlaufzeit, keine Hürden — wir wollen dich nur halten, solange du echten Nutzen siehst.",
        },
      ],
    },
    contact: {
      overline: "Kontakt",
      titleA: "Schreib uns,",
      titleB: "wenn du",
      titleC: "Klarheit suchst.",
      blurb:
        "Presse-Anfragen, Kooperationen, Themen-Vorschläge für den Podcast — wir lesen jede Nachricht.",
      name: "Name",
      email: "E-Mail",
      company: "Organisation",
      message: "Worum geht's?",
      submit: "Nachricht senden",
      submitting: "Wird gesendet…",
      success: "Danke. Wir melden uns innerhalb von 48 Stunden.",
      error: "Etwas ist schiefgelaufen. Versuch es bitte erneut.",
      rateLimit: "Zu viele Versuche. Bitte warte ein paar Minuten.",
      placeholders: {
        name: "Vorname Nachname",
        email: "name@beispiel.ch",
        company: "Optional",
        message: "Schreib uns ein paar Sätze…",
      },
    },
    newsletter: {
      title: "Bleib wach.",
      subtitle:
        "Sonntags eine Mail. Keine Werbung. Nur die wichtigsten Red Flags der Woche.",
      placeholder: "deine@email.ch",
      cta: "Eintragen",
      success: "Eingetragen. Check dein Postfach.",
      error: "Konnte nicht abonnieren. Bitte später erneut versuchen.",
    },
    footer: {
      tagline: "Erkenne die Warnsignale, bevor sie dein Leben bestimmen.",
      address: "Eine Initiative der Schweizer Akademie für Transformation GmbH · in Zusammenarbeit mit der Herzbewegung · Zürich",
      cols: {
        platform: "Plattform",
        ecosystem: "Ökosystem",
        legal: "Rechtliches",
      },
      links: {
        podcast: "Podcast",
        academy: "Academy",
        membership: "Membership",
        selftest: "Selbsttest",
        sat: "SAT Akademie",
        herzbewegung: "Herzbewegung",
        about: "Über",
        imprint: "Impressum",
        privacy: "Datenschutz",
        terms: "AGB",
      },
      rights: "Alle Rechte vorbehalten.",
    },
    podcastDetail: {
      back: "Alle Folgen",
      duration: "Dauer",
      released: "Veröffentlicht",
      listen: "Folge anhören",
      transcript: "Transkript",
      keyTakeaways: "Kernaussagen",
      relatedTitle: "Weitere Folgen",
    },
  },

  en: {
    nav: {
      home: "Home",
      podcast: "Podcast",
      academy: "Academy",
      about: "About",
      contact: "Contact",
      cta: "Membership",
    },
    hero: {
      eyebrow: "Recognise the warning signs",
      titleLine1: "Before they shape",
      titleLine2: "your entire life.",
      subtitle:
        "The RED FLAG Podcast and Academy stand for awareness, clarity and real change. For anyone ready to look closer.",
      ctaPrimary: "Listen to podcast",
      ctaSecondary: "Learn more",
      pillars: [
        { title: "Podcast", desc: "Honest conversations. No filters. Every Monday." },
        { title: "Academy", desc: "Knowledge that moves you forward. Courses for real growth." },
        { title: "Community", desc: "Like-minded people. Exchange. Growth together." },
        { title: "Mission", desc: "Create awareness. Inspire people." },
      ],
    },
    categories: {
      overline: "Topics",
      title: "Six areas. One truth.",
      subtitle:
        "RED FLAG exposes the warning signs — in relationships, psyche, work and society.",
      items: [
        {
          slug: "beziehungen",
          icon: "Heart",
          title: "Relationships",
          tags: "Narcissism · Gaslighting · Cheating · Co-dependency",
          desc: "Spot the red flags before the relationship destroys you.",
        },
        {
          slug: "psychologie",
          icon: "Brain",
          title: "Psychology",
          tags: "Trauma · Attachment · Manipulation · Shadow",
          desc: "Understand the patterns that have been holding you for years.",
        },
        {
          slug: "maenner",
          icon: "User",
          title: "Men",
          tags: "Dating · Masculinity · Communication",
          desc: "Clarity on roles no one explains anymore — honest, unflinching.",
        },
        {
          slug: "frauen",
          icon: "UserCircle",
          title: "Women",
          tags: "Worth · Boundaries · Self-respect",
          desc: "What you were never taught — about yourself and the other sex.",
        },
        {
          slug: "beruf",
          icon: "Briefcase",
          title: "Work",
          tags: "Toxic bosses · Burnout · Mobbing",
          desc: "When the job eats you up — warning signs in organisations.",
        },
        {
          slug: "gesellschaft",
          icon: "Globe2",
          title: "Society",
          tags: "Group pressure · Media · Manipulation",
          desc: "Where the majority is wrong — and how you stay clear.",
        },
      ],
    },
    podcast: {
      overline: "RED FLAG Podcast",
      title: "Weekly episodes that don't sugar-coat.",
      subtitle:
        "New episode every Monday. On Spotify, Apple Podcasts and wherever podcasts live.",
      ctaAll: "All episodes",
      ctaListen: "Listen",
    },
    selftest: {
      overline: "Self-test",
      title: "How many red flags are currently in your life?",
      subtitle:
        "Answer 12 honest questions. Get a clear assessment instantly — anonymous, free, no signup.",
      cta: "Start the test",
      note: "≈ 4 minutes · Honest answers expected",
    },
    testimonials: {
      overline: "Community voices",
      title: "What listeners say.",
      items: [
        {
          quote:
            "After three episodes I had the truth about my relationship — the one I'd been avoiding for five years.",
          name: "Lisa M.",
          role: "Zurich",
        },
        {
          quote:
            "RED FLAG gave me the vocabulary to finally understand what's happening between me and my boss.",
          name: "David K.",
          role: "Hamburg",
        },
        {
          quote:
            "Sharp, unflinching, never cynical. Exactly the voice missing in our world.",
          name: "Anna R.",
          role: "Vienna",
        },
      ],
    },
    membership: {
      overline: "Membership",
      title: "Three ways to go deeper.",
      subtitle:
        "From free entry to a close-knit community. Choose how far you want to go.",
      tiers: [
        {
          name: "Free",
          price: "CHF 0",
          period: "",
          desc: "The weekly podcast and the Sunday newsletter briefing.",
          features: [
            "Podcast — all episodes free",
            "Newsletter every Sunday",
            "Access to the self-test",
          ],
          cta: "Start free",
        },
        {
          name: "Insider",
          price: "CHF 19",
          period: "/ month",
          desc: "Deeper content and live sessions for the seriously curious.",
          features: [
            "Everything in Free",
            "Bonus episodes & deep dives",
            "Monthly live Q&A",
            "Mini-courses (relationships, psyche, work)",
            "Ad-free feed",
          ],
          cta: "Become Insider",
          highlight: true,
          badge: "Popular",
        },
        {
          name: "Inner Circle",
          price: "CHF 99",
          period: "/ month",
          desc: "Direct access. Small group. Real transformation.",
          features: [
            "Everything in Insider",
            "Private community (max 200)",
            "Monthly group call",
            "SAT path: 30% discount",
            "Personal voice note on your birthday",
          ],
          cta: "Apply",
        },
      ],
    },
    ecosystem: {
      overline: "The ecosystem",
      title: "RED FLAG is only the beginning.",
      subtitle:
        "Three brands — one mission. RED FLAG reveals the warning signs, the Swiss Academy for Transformation GmbH guides real change, and Herzbewegung carries the result into the world.",
      steps: [
        {
          tag: "01",
          name: "RED FLAG",
          role: "Recognise",
          desc: "You see what's there — and stop lying to yourself.",
        },
        {
          tag: "02",
          name: "SAT",
          role: "Transform",
          desc: "The academy guides you through real change.",
        },
        {
          tag: "03",
          name: "Herzbewegung",
          role: "Embody",
          desc: "You pass on what changed you. The movement.",
        },
      ],
    },
    faq: {
      overline: "Common questions",
      title: "What you should know.",
      items: [
        {
          q: "Is RED FLAG therapy or coaching?",
          a: "No. RED FLAG is an awareness platform. We give you language, models and patterns — not diagnoses. For deep work we point to SAT or qualified therapists.",
        },
        {
          q: "How is RED FLAG different from SAT and Herzbewegung?",
          a: "RED FLAG shows the warning signs (recognise). SAT offers the transformation path (change). Herzbewegung carries the result into the world (embody). Three brands, one clear path.",
        },
        {
          q: "How often does the podcast come out?",
          a: "Every Monday at 06:00. Insiders additionally get bonus episodes and deep dives.",
        },
        {
          q: "Can I become a member without knowing the podcast?",
          a: "Yes — but we recommend listening to three episodes first to feel if our voice fits you.",
        },
        {
          q: "How do I cancel the membership?",
          a: "Anytime with one click in your account. No minimum term, no friction — we only want to keep you as long as you see real value.",
        },
      ],
    },
    contact: {
      overline: "Contact",
      titleA: "Write to us",
      titleB: "when you're",
      titleC: "looking for clarity.",
      blurb:
        "Press, partnerships, topic suggestions for the podcast — we read every message.",
      name: "Name",
      email: "Email",
      company: "Organisation",
      message: "What's it about?",
      submit: "Send message",
      submitting: "Sending…",
      success: "Thanks. We'll respond within 48 hours.",
      error: "Something went wrong. Please try again.",
      rateLimit: "Too many attempts. Please wait a few minutes.",
      placeholders: {
        name: "First Last",
        email: "name@example.com",
        company: "Optional",
        message: "Write us a few lines…",
      },
    },
    newsletter: {
      title: "Stay sharp.",
      subtitle:
        "One Sunday email. No ads. Just the most important red flags of the week.",
      placeholder: "you@email.com",
      cta: "Subscribe",
      success: "Subscribed. Check your inbox.",
      error: "Could not subscribe. Please try again later.",
    },
    footer: {
      tagline: "Recognise the warning signs before they shape your life.",
      address: "An initiative of the Swiss Academy for Transformation GmbH · in collaboration with the Herzbewegung community · Zurich",
      cols: {
        platform: "Platform",
        ecosystem: "Ecosystem",
        legal: "Legal",
      },
      links: {
        podcast: "Podcast",
        academy: "Academy",
        membership: "Membership",
        selftest: "Self-test",
        sat: "SAT Academy",
        herzbewegung: "Herzbewegung",
        about: "About",
        imprint: "Imprint",
        privacy: "Privacy",
        terms: "Terms",
      },
      rights: "All rights reserved.",
    },
    podcastDetail: {
      back: "All episodes",
      duration: "Duration",
      released: "Released",
      listen: "Listen to episode",
      transcript: "Transcript",
      keyTakeaways: "Key takeaways",
      relatedTitle: "More episodes",
    },
  },
};
